// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-about-mycolor[data-v-714c45b0]{align-items:center;background-color:#555;color:#fff;display:flex;font-size:12px;justify-content:center;margin:0 -15px;padding:5px}@media (max-width:320px){.c-about-mycolor[data-v-714c45b0]{font-size:10px}}", ""]);
// Exports
module.exports = exports;
